import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { StorageService } from '../services/storage-service.service';
import { applicationServer } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private storage: StorageService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Il token va solo al nostro backend: le chiamate verso terzi (es. api.weatherapi.com)
    // non devono riceverlo. Il servizio newsletter imposta il proprio header da sé.
    if (!req.url.startsWith(applicationServer + '/')) {
      return next.handle(req);
    }

    // Lista degli endpoint pubblici che non necessitano di autenticazione
    const publicEndpoints = [
      '/rest/public/',
      '/rest/version/',
    ];

    // Verifica se l'URL è un endpoint pubblico
    const isPublicEndpoint = publicEndpoints.some(endpoint => req.url.includes(endpoint));

    // Se è un endpoint pubblico, procedi senza aggiungere il token
    if (isPublicEndpoint) {
      return next.handle(req);
    }

    // Per tutti gli altri endpoint, aggiungi il token Bearer
    return from(this.storage.get('token')).pipe(
      switchMap(token => {
        // Se il token esiste, clona la richiesta e aggiungi l'header Authorization
        if (token) {
          const clonedReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          return next.handle(clonedReq);
        }

        // Se non c'è token, procedi comunque con la richiesta originale
        return next.handle(req);
      }),
      catchError(error => {
        // Gestione errori (opzionale: qui potresti gestire errori 401/403)
        return throwError(() => error);
      })
    );
  }
}
